<p-blockUI [blocked]="visible">
  <div
    class="flex flex-column align-items-center order-submission-loading-container"
    data-cy="order-submission-loading-overlay"
  >
    <div
      class="flex align-items-center justify-content-start py-5 px-5 w-full order-submission-instructions text-white bg-primary-blue-base"
    >
      <div class="mr-3">
        <app-glyph-spinner color="white"></app-glyph-spinner>
      </div>
      <div>
        <p class="my-0 p4">Please be patient while we process your order</p>
        <p class="my-0 p4">Please do not refresh the page</p>
        <p class="my-0 p4">Please do not exit the page</p>
      </div>
    </div>
    <div class="py-3 px-5 w-full bg-white">
      <p class="my-0 p4 loading-dots">We are processing your order</p>
    </div>
  </div>
</p-blockUI>
